<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Multiple Select
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <ng-container *ngIf="isBrowser;else noJsContent">
      <h2>Customized useCase options for Table</h2>
      <div class="content__tools-wrap">
        <div class="content__row">
          <label for="useCase" class="content__row-label">Use Cases</label>
          <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
            <ng-container *ngFor="let useCase of useCases">
              <option [value]="useCase">{{ useCase }}</option>
            </ng-container>
          </select>
        </div>
      </div>
    <div *ngIf="selectedUseCase === 'SelectWithChipsInput'">
      <h2>Select With Chips Input</h2>
      <form action="/multi-select" method="get" id="form2">
        <maced-multi-select multiSelectId="multiSelectId" ariaLabel="multi select search" placeholder="placeholder"
          formId="form2" [maximumVisibleChips]="4" label="Select" multiSelectLabelId="multiSelectLabelId"
          [selectedOptionList]="selectedOptionList" [options]="options" (optionEvent)="onClickOption($event)">
          <ng-container ngProjectAs="[message]">
            <div class="c-multiselect__helper-text">
              Helper text
            </div>
          </ng-container>
        </maced-multi-select>
      </form>
      <p>Selcted Options:-</p>
      <ng-container *ngIf="selectedOptionList.length > 0">
        <p *ngFor="let option of selectedOptionList">
          {{ option.label }}
        </p>
      </ng-container>
    
    </div>
    <div *ngIf="selectedUseCase === 'InlineSelect'">
      <h2>Inline Select</h2>
      <maced-multi-select multiSelectId="multiSelectId2" ariaLabel="select" placeholder="placeholder" label="Select"
        [selectedOptionList]="selectedOptionList2" multiSelectLabelId="multiSelectLabelId1" [isInlineSelect]="true" [options]="options2"
        (optionEvent)="onClickOption2($event)">
        <ng-container ngProjectAs="[message]">
          <div class="c-multiselect__helper-text">
            Helper text
          </div>
        </ng-container>
      </maced-multi-select>
    </div>

    <div *ngIf="selectedUseCase === 'MultiSections'">
      <h2>Multi-sections</h2>
      <maced-multi-select multiSelectId="multiSelectId8" ariaLabel="Select" placeholder="placeholder" label="Select"
        [selectedOptionList]="selectedOptionList4" multiSelectLabelId="multiSelectLabelId8" [options]="options8" [maximumVisibleChips]="1"
        (optionEvent)="onClickOption4($event)" [hasTruncation]="true">
        <ng-container ngProjectAs="[message]">
          <div class="c-multiselect__helper-text">
            Helper text
          </div>
        </ng-container>
      </maced-multi-select>
    </div>

    <div *ngIf="selectedUseCase === 'ErrorMode'">
      <h2>Error</h2>
      <maced-multi-select multiSelectId="multiSelectId3" ariaLabel="select" placeholder="placeholder" label="Select" [maximumVisibleChips]="4" 
        [selectedOptionList]="selectedOptionList3" [helperTextId]="helperTextId" multiSelectLabelId="multiSelectLabelId2" [hasError]="true" [options]="options5" [required]="true"
        (optionEvent)="onClickOption3($event)">
        <ng-container ngProjectAs="[message]">
          <div class="c-multiselect__helper-text" [id]="helperTextId">
            Helper text for Error state
          </div>
        </ng-container>
      </maced-multi-select>
    </div>

    <div *ngIf="selectedUseCase === 'DisabledMode'">
      <h2>Disabled</h2>
      <maced-multi-select multiSelectId="multiSelectId4" multiSelectLabelId="multiSelectLabelId3" ariaLabel="Multi-select Dropdown list navigate with tab" placeholder="placeholder" label="Select"
        [options]="options3" [disabled]="true">
        <ng-container ngProjectAs="[message]">
          <div class="c-multiselect__helper-text">
            Helper text
          </div>
        </ng-container>
      </maced-multi-select>
    </div>

    <div *ngIf="selectedUseCase === 'InLineSelectWithDisabledMode'">
      <h2>In Line Select Disabled</h2>
      <maced-multi-select multiSelectId="multiSelectId5" multiSelectLabelId="multiSelectLabelId4" ariaLabel="Select" placeholder="placeholder" label="Select"
        [isInlineSelect]="true" [options]="options4" [disabled]="true">
      </maced-multi-select>
    </div>

    <div *ngIf="selectedUseCase === 'SelectOnlySingleOption'">
      <h2>Select With Chips Input</h2>
      <form action="/multi-select" method="get" id="form8">
        <maced-multi-select multiSelectId="multiSelectId8" ariaLabel="multi select search" placeholder="placeholder"
          formId="form8" label="Select" multiSelectLabelId="multiSelectLabelId8" [selectedOptionList]="selectedOptionList8"
          [hasSingleOptionSelected]="true" [hasCheckboxesDropdown]="false" [options]="options9" (optionEvent)="onClickOption8($event)">
          <ng-container ngProjectAs="[message]">
            <div class="c-multiselect__helper-text">
              Helper text
            </div>
          </ng-container>
        </maced-multi-select>
      </form>
      <p>Selcted Options:-</p>
      <ng-container *ngIf="selectedOptionList8.length > 0">
        <p *ngFor="let option of selectedOptionList8">
          {{ option.label }}
        </p>
      </ng-container>
    
    </div>
  </ng-container>

  <ng-template #noJsContent>
    <h2>Case-1 : With Form Id</h2>
    <form action="/multi-select" method="get" id="form1">
      <maced-multi-select multiSelectId="multiSelectId6" ariaLabel="Select" placeholder="placeholder" label="label"
       formId="form1" [options]="options6" [selectedOptionList]="selectedOptionList">
      </maced-multi-select>
      <div class="c-multi-select__height--modifier">
        <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button>
      </div>
    </form>
    <p>Selcted Options:-</p>
    <ng-container *ngIf="options.length > 0">
      <ng-container *ngFor="let option of options">
        <p *ngIf="option.checked">
          {{ option.label }}
        </p>
      </ng-container>
    </ng-container>

    <h2>Case-2 : Without Form Id</h2>
    <form action="/multi-select" method="get">
      <maced-multi-select multiSelectId="multiSelectId7" ariaLabel="Select" placeholder="placeholder" label="label"
       [options]="options7" [selectedOptionList]="selectedOptionList7">
      </maced-multi-select>
      <div class="c-multi-select__height--modifier">
        <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button>
      </div>
    <p>Selcted Options:-</p>
    <ng-container *ngIf="options.length > 0">
      <ng-container *ngFor="let option of options7">
        <p *ngIf="option.checked">
          {{ option.label }}
        </p>
      </ng-container>
    </ng-container>
  </form>
  <h2>Case-3 : Multi-sections</h2>
  <form action="/multi-select" method="get">
    <maced-multi-select multiSelectId="multiSelectId8" ariaLabel="Select" placeholder="placeholder" label="Select"
    [selectedOptionList]="selectedOptionList4" multiSelectLabelId="multiSelectLabelId8" [options]="options8"
    (optionEvent)="onClickOption4($event)" [hasTruncation]="true">
    <ng-container ngProjectAs="[message]">
      <div class="c-multiselect__helper-text">
        Helper text
      </div>
    </ng-container>
  </maced-multi-select>
    <div class="c-multi-select__height--modifier">
      <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button>
    </div>
  <p>Selcted Options:-</p>
  <ng-container *ngIf="options8.length > 0">
    <ng-container *ngFor="let option of options8">
      <p *ngIf="option.checked">
        {{ option.label }}
      </p>
    </ng-container>
  </ng-container>
</form>

<h2>Case-4 : Select With Chips Input</h2>
<form action="/multi-select" method="get" id="form2">
  <maced-multi-select multiSelectId="multiSelectIdNoJs" ariaLabel="multi select search" placeholder="placeholder"
    formId="form2" label="Select" multiSelectLabelId="multiSelectLabelId" [selectedOptionList]="selectedOptionListNoJs"
    [hasSingleOptionSelected]="true" [hasCheckboxesDropdown]="false" [options]="noJsOptions"
    (optionEvent)="onClickOption($event)">
    <ng-container ngProjectAs="[message]">
      <div class="c-multiselect__helper-text">
        Helper text
      </div>
    </ng-container>
  </maced-multi-select>
  <p>Selcted Options:-</p>
  <ng-container *ngIf="selectedOptionListNoJs.length > 0">
    <p *ngFor="let option of selectedOptionListNoJs">
      {{ option.label }}
    </p>
  </ng-container>
</form>
  </ng-template>
</div>